import axios from "axios";
import { getToken, baseUrl } from "./baseUrl";

const PostUpdateData = async ({ endPoint, method, obj }) => {
  console.log("entered");
  try {
    const response = await axios({
      url: `${baseUrl}${endPoint}`,
      method: method,
      data: obj,
      headers: {
        tymeplusjwt: getToken(), // read the token fresh on every call
      },
    });

    console.log("response-->", response);
    return response.data;
  } catch (error) {
    console.error("error---->", error);
    throw error;
  }
};

export default PostUpdateData;